export enum CourseName {
  BasicMatura = 'matura-course',
  SecondarySchool = 'secondary-school-course',
  Exam = 'exam-course',
}

export enum CourseDisplayName {
  BasicMatura = 'Kurs maturalny',
  SecondarySchool = 'Kurs dla szkoły średniej',
  Exam = 'Kurs do egzaminu 8kl',
}

export const courseNameToCourseDisplayName = new Map<
  CourseName,
  CourseDisplayName
>([
  [CourseName.BasicMatura, CourseDisplayName.BasicMatura],
  [CourseName.SecondarySchool, CourseDisplayName.SecondarySchool],
  [CourseName.Exam, CourseDisplayName.Exam],
]);
